
import XImg from 'vux/src/components/x-img/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'

export default {
data () {
return {
$vue: '',
userName: '', // 用户登录名
pictureUrl: '', // 头像
collectionCaseCount: '', // 收藏病例数量
filmCountByDoctorId: '', // 阅片数量
orderCountByDoctorId: '', // 预约数量
isAuth: '',
isEdit: true, // 是否显示编辑图标
personInfoHeader: true,
renzheng: '../../../static/img/renzheng.png',
bianji: '../../../static/img/bianji.png',
fenge: '../../../static/img/fenge.png',
mrPictureUrl: '../../../static/img/touxiang.png',
edit: '0' 
}
},
components: { XImg, Scroller },
methods: {
/**
* @author      dongkuoji
* @description 跳转到个人信息修改页面
* @date        2018/4/20 15:20
*/
personInfoEdit () {
if (this.$route.name === 'PersonInfoEdit') {
this.isEdit = false
this.$router.push({name: 'PersonInfoEdit'})
} else if (this.$route.name === 'PersonInfoDetail') {
this.edit = '0'
this.isEdit = true
}
},

collectionCaseList () {
this.$router.push({path: '/collection'})
},

goYzdList () {
this.$router.push({name: 'YzdCaseList'})
},

async goMessageCenter () {
this.$router.push({path: '/messagecenter'})
},
/**
* @author      dongkuoji
* @description 方法描述:获取用户基本信息
* @date        2018/5/8 19:22
*/
async getUserInfo () {
this.$http.post(this.$vue.getData('PERSONINFO_URL')).then(suc => {
let data = suc.data.data
this.userName = data.USERNAME 
this.pictureUrl = data.PICTURE_URL 
this.isAuth = data.STATUS 
this.collectionCaseCount = data.collectionCaseCount 
this.filmCountByDoctorId = data.filmCountByDoctorId 
this.orderCountByDoctorId = data.orderCountByDoctorId 
})
}
},
beforeMount () {
this.$vue = this 
this.getUserInfo()
this.personInfoEdit()
},
mounted () {
},
watch: {

'$route' (to, from) {
if (to.name === 'PersonInfoDetail') {
this.edit = '0'
this.isEdit = true
} else if (to.name === 'PersonInfoEdit' && this.edit === '1') {
this.$router.push({name: 'HomePage'})
} else if (to.name === 'PersonInfoEdit') {
this.isEdit = false
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/doctor/user/personInfo.vue